var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c(_vm.currentView,{tag:"component",on:{"update":_vm.updateReceipt,"submit":_vm.submitReceipt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }